/**
 * Chart marker colors (browser-safe; no theme / RN imports).
 * Values match `src/theme/modules/default.js` colors used by markerTypes.
 */
const TV_CHART_MARKER_COLORS = {
  info: "#6FA6CD",
  warning: "#FDD02E",
  errorText: "#BA0E0E",
  error: "#F03E3E",
  success: "#12B886",
  baseGreyDark3: "#878DAA",
  baseGrey: "#909193"
};

export default TV_CHART_MARKER_COLORS;
